import { render, staticRenderFns } from "./2DKanban.vue?vue&type=template&id=2e8fa7cc&scoped=true&"
import script from "./2DKanban.vue?vue&type=script&lang=js&"
export * from "./2DKanban.vue?vue&type=script&lang=js&"
import style0 from "./2DKanban.vue?vue&type=style&index=0&id=2e8fa7cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8fa7cc",
  null
  
)

export default component.exports